import { Chip, Grid } from '@material-ui/core';
import { getStudentAffiliate } from '@webapps/business';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { RYTHME_SCOLAIRE } from 'config/constants';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';
import {
  DescriptionRounded as DescriptionIcon,
  Work as WorkIcon,
  HomeWorkRounded as HomeWorkIcon,
  PersonRounded as PersonRoundedIcon,
  Event as EventIcon,
  AutorenewRounded as AutorenewIcon,
} from '@material-ui/icons';

const InfoContract = ({ info, typeOrganism }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { data: { data: infoContrat = [] } = {} } = useQuery(
    getStudentAffiliate,
    {
      key: ['infoStudentSchoolAffiliatee', info?.id],
      variables: { id: info?.id, type: typeOrganism, status: 'enclosed' },
    }
  );

  return (
    <div className={cx(classes.container)}>
      <div className={cx(global.title, classes.title)}>Contrat</div>
      {!infoContrat[0]?.contract ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
        <FormattedMessage id="noElements" />
      </div>
      ) : (
        <>
          <div className={classes.cellTable}>
            <div className={cx(global.infoText, classes.address)}> <EventIcon className={global.infoIcon} /> Date du contrat : <span className={classes.span}>
              <FormattedDate
              day="numeric"
              month="long"
              value={infoContrat[0]?.contract?.startDate}
              year="numeric"
              />{' '}
              à{' '}
              <FormattedDate
                day="numeric"
                month="long"
                value={infoContrat[0]?.contract?.endDate}
                year="numeric"
            /></span></div>
          </div>
          <div className={classes.cellTable}>
            <div className={cx(global.infoText, classes.address)}> <AutorenewIcon className={global.infoIcon} /> Rythme scolaire : <span className={classes.span}>{RYTHME_SCOLAIRE.filter(({ value }) => value === infoContrat[0]?.contract?.schoolSystem)[0]?.label || ""}</span></div>
          </div>
          <div className={classes.contractInfo}>
            <div className={classes.cellTable}>
              <div className={cx(global.infoText, classes.address)}> <HomeWorkIcon className={global.infoIcon} /> École : <span className={classes.span}>{infoContrat[0]?.contract?.school?.name || ""}</span></div>
            </div>
            <div className={classes.cellTable}>
              <div className={cx(global.infoText, classes.address)}> <EventIcon className={global.infoIcon} /> Date de signature : <span className={classes.span}>{infoContrat[0]?.contract?.schoolSignDate && (
                <FormattedDate
                  day="numeric"
                  month="long"
                  value={infoContrat[0]?.contract?.schoolSignDate}
                  year="numeric"
                />
              )}{infoContrat[0]?.contract?.schoolSignAction === 'SIGNED' ? (
                <Chip
                  classes={{
                    colorPrimary: css({
                      background: '#dbfad8',
                      color: 'green',
                      marginLeft: spacing(1),
                    }),
                  }}
                  // className={css({ margin: spacing(0.5) })}
                  color="primary"
                  label="Signé"
                  size="small"
                />
              ) : (
                <Chip
                  classes={{
                    colorPrimary: css({
                      background: '#FAE8D7',
                      color: '#F50057',
                      marginLeft: spacing(1),
                    }),
                  }}
                  // className={css({ margin: spacing(0.5) })}
                  color="primary"
                  label="En attente"
                  size="small"
                />
              )}</span></div>
            </div>
          </div>
          <div className={classes.contractInfo}>
            <div className={classes.cellTable}>
              <div className={cx(global.infoText, classes.address)}> <HomeWorkIcon className={global.infoIcon} /> Entreprise : <span className={classes.span}>{infoContrat[0]?.contract?.business ? infoContrat[0]?.contract?.business?.name : infoContrat[0]?.contract?.externalName}</span></div>
            </div>
            <div className={classes.cellTable}>
              <div className={cx(global.infoText, classes.address)}> <EventIcon className={global.infoIcon} /> Date de signature : <span className={classes.span}>{infoContrat[0]?.contract?.businessSignDate && (
                <FormattedDate
                  day="numeric"
                  month="long"
                  value={infoContrat[0]?.contract?.businessSignDate}
                  year="numeric"
                />
              )}{infoContrat[0]?.contract?.businessSignAction === 'SIGNED' ? (
                <Chip
                  classes={{
                    colorPrimary: css({
                      background: '#dbfad8',
                      color: 'green',
                      marginLeft: spacing(1),
                    }),
                  }}
                  // className={css({ margin: spacing(0.5) })}
                  color="primary"
                  label="Signé"
                  size="small"
                />
              ) : (
                <Chip
                  classes={{
                    colorPrimary: css({
                      background: '#FAE8D7',
                      color: '#F50057',
                      marginLeft: spacing(1),
                    }),
                  }}
                  // className={css({ margin: spacing(0.5) })}
                  color="primary"
                  label="En attente"
                  size="small"
                />
              )}</span></div>
            </div>
          </div>
          <div className={classes.contractInfo}>
            <div className={classes.cellTable}>
              <div className={cx(global.infoText, classes.address)}> <PersonRoundedIcon className={global.infoIcon} /> Apprenant : <span className={classes.span}>{info?.firstname} {info?.lastname}</span></div>
            </div>
            <div className={classes.cellTable}>
              <div className={cx(global.infoText, classes.address)}> <EventIcon className={global.infoIcon} /> Date de signature : <span className={classes.span}>{infoContrat[0]?.contract?.studentSignDate && (
                <FormattedDate
                  day="numeric"
                  month="long"
                  value={infoContrat[0]?.contract?.studentSignDate}
                  year="numeric"
                />
              )}{infoContrat[0]?.contract?.studentSignAction === 'SIGNED' ? (
                <Chip
                  classes={{
                    colorPrimary: css({
                      background: '#dbfad8',
                      color: 'green',
                      marginLeft: spacing(1),
                    }),
                  }}
                  // className={css({ margin: spacing(0.5) })}
                  color="primary"
                  label="Signé"
                  size="small"
                />
              ) : (
                <Chip
                  classes={{
                    colorPrimary: css({
                      background: '#FAE8D7',
                      color: '#F50057',
                      marginLeft: spacing(1),
                    }),
                  }}
                  // className={css({ margin: spacing(0.5) })}
                  color="primary"
                  label="En attente"
                  size="small"
                />
              )}</span></div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: spacing(2),
  },
  title: {
    borderLeft: '3px solid #0060F9',
    lineHeight: '100%',
    paddingLeft: spacing(1),
    marginBottom: spacing(1.5)
  },
  infoContainer: {
    display: 'flex',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: spacing(1),
    '@media (max-width: 430px)': {
      flexDirection: 'column'
    }
  },
  span: {
    color: '#152652',
    marginLeft: spacing(0.5),
  },
  cellTable: {
    width: '100%',
  },
  contractInfo: {
    marginTop: spacing(2),
  }
});

InfoContract.propTypes = {
  info: PropTypes.object,
  typeOrganism: PropTypes.string,
};

export default InfoContract;
